import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VmeCommonModule } from '../../vme-common.module';
import { VMEComponentsModule } from '../../vme-components.module';
import { VmeDirectivesModule } from '../../vme-directives.module';
import { VmePipesModule } from '../../vme-pipes.module';
import { MobileBrandingComponent } from './mobile-branding.component';

const routes: Routes = [
  { path: '', component: MobileBrandingComponent, data: { title: 'Mobile Branding' } },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MobileBrandingRoutingModule {}

@NgModule({
  imports: [
    MobileBrandingRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
  ],
  declarations: [MobileBrandingComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class MobileBrandingModule {}
